/* eslint-disable no-undef */

import { phoneFormatter } from 'merchant/services/Helper.service';

// @ts-nocheck
let commonAnalyticsData;
const createBody = (data?) => {
  return {
    Tag: 'GoKwik',
    Currency: commonAnalyticsData?.currency,
    'Promo Code': commonAnalyticsData?.coupon || '',
    'Cart Total Price': +commonAnalyticsData?.cart_after_discount,
    Products: commonAnalyticsData.products,
    ...commonAnalyticsData?.marketingData,
    ...data,
  };
};

export const setNoteAttribute = (note_attributes) => {
  if (webengage.user && typeof webengage.user.getAnonymousId === 'function')
    note_attributes.push(
      { name: 'LUID', value: webengage.user.getAnonymousId() },
      {
        name: 'SESSION_ID',
        value:
          webengage.user.getAnonymousId() + '-' + webengage.getLicenseCode() + '-' + webengage.state.getSession().suid,
      }
    );
  if (webengage.user && typeof webengage.getLicenseCode === 'function')
    note_attributes.push({ name: 'LICENSE_CODE', value: webengage.getLicenseCode() });
  return note_attributes;
};
export const callWebEngage = (eventName, data) => {
  data?.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  if (eventName === 'Started_Checkout_GK') {
    webengageCheckoutStarted(data);
  } else if (eventName === 'phoneNumber') {
    webengagePhoneNumber(data);
  } else if (eventName === 'pinCode') {
    webengagePinCode(data);
  } else if (eventName === 'paymentMethod') {
    webengagePaymentMethod(data);
  } else if (eventName === 'paymentCompleted') {
    webengagePaymentCompletedGK(data);
  } else if (eventName === 'paymentCompletedNeemans') {
    webengagePaymentCompleted(data);
  } else if (eventName === 'userAddress') {
    webengageUserAddress(data);
  } else if (eventName === 'userLoginEvent') {
    data.analyticsPixelObj?.webengage?.value === 'customer_id' && webengage?.user?.login(data.id);
  } else if (eventName === 'coupon_applied_success_gk' || eventName === 'coupon_applied_failed_gk') {
    webengageDiscountEvent(eventName, data);
  }
};

const webengageDiscountEvent = (eventName, data) => {
  const credentials = {
    eventName: eventName,
    data: createBody({
      'Mobile Number': '+91' + data.phoneNumber?.trim(),
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email?.trim().toLowerCase(),
      'Promo Code': data?.evt?.coupon_code,
      amount_saved: !isNaN(parseFloat(data.evt.amount_saved)) ? parseFloat(data.evt.amount_saved) : 0,
      checkout_step: data?.evt?.checkout_step?.split(' ')[0].trim() || '',
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'] || '',
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'] || '',
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'] || '',
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'] || '',
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'] || '',
      'Abandoned URL': data.abcURL,
    }),
  };

  webengage.track(credentials.eventName, credentials.data);
};

const webengagePhoneNumber = (data) => {
  let phone = data.evt?.phoneNumber?.trim().toLowerCase();
  data.analyticsPixelObj?.webengage?.value === 'phone' &&
    webengage.user.login(phoneFormatter(phone, data.analyticsPixelObj?.webengage));
  phone && webengage.user.setAttribute('we_phone', `+91${phone}`);
  webengage.user.setAttribute('userTag', 'GoKwik');
  webengage.user.setAttribute('we_email_opt_in', true);
  webengage.user.setAttribute('we_whatsapp_opt_in', true);
  webengage.user.setAttribute('we_sms_opt_in', true);
  webengageMobileGK(data);
};

const webengageMobileGK = (data) => {
  let credentials = {
    eventName: 'Mobile_Added_GK',
    data: createBody({
      'Mobile Number': '+91' + data.evt.phoneNumber?.trim(),
      'product ID': data.commonAnalyticsData.pidArr.join(','),
      'product Name': data.commonAnalyticsData.product_name_array.join(','),
      'Product Quantity': data.commonAnalyticsData.products.map((a) => a['Product Quantity']),
      'Product Variant ID': data.commonAnalyticsData.products.map((a) => a['Product Variant Id']),
      'Product Price': data.commonAnalyticsData.products.map((a) => a['Product Price']),
      Currency: data.commonAnalyticsData.currency,
      'Image URL': data.commonAnalyticsData.imgUrlArr,
      'Product Url': data.commonAnalyticsData.products.map((a) => a['Product Url']),
      'Promo Code': data?.commonAnalyticsData.coupon,
      'Cart Total Price': +data.commonAnalyticsData.cart_total_price,
      'Product ID': data.commonAnalyticsData.pidArr,
      'Product Name': data.commonAnalyticsData.product_name_array,
      'Abandoned URL': data.abcURL,
      ABC_sms: data.abcURL + `&ch=webeng&src=sms`,
      ABC_mail: data.abcURL + `&ch=webeng&src=mail`,
      ABC_wa: data.abcURL + `&ch=webeng&src=wa`,
      ABC_limechat: data.abcURL + `&ch=webeng&src=limechat`,
      ABC_zoko: data.abcURL + `&ch=webeng&src=zoko`,
      ABC_gupshup: data.abcURL + `&ch=webeng&src=gupshup`,
    }),
  };
  webengage.track(credentials.eventName, credentials.data);
};

const webengageCheckoutStarted = (data) => {
  let credentials = {
    eventName: 'Started_Checkout_GK',
    data: createBody(),
  };
  webengage.track(credentials.eventName, credentials.data);
};

const webengagePinCode = (data) => {
  let credentials = {
    analyticsName: 'webengage',
    eventName: 'PIN_Code_Added_GK',
    data: createBody({
      Pincode: '' + data.evt.pincode,
    }),
  };
  webengage.track(credentials.eventName, credentials.data);
};

const webengagePaymentMethod = (data) => {
  let credentials = {
    eventName: 'Payment_Method_Selected_GK',
    data: createBody({
      'Mobile Number': '+91' + data.phoneNumber?.trim(),
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email?.trim().toLowerCase(),
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: +data.userAddress?.pincode,
      'Address Type': data.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.evt.paymentMethod,
      'Promo Code': data?.commonAnalyticsData.coupon,
      'product ID': data.commonAnalyticsData.pidArr.join(','),
      'Product ID': data.commonAnalyticsData.pidArr,
      'product Name': data.commonAnalyticsData.product_name_array.join(','),
      'Product Name': data.commonAnalyticsData.product_name_array,
    }),
  };
  webengage.track(credentials.eventName, credentials.data);
};

const webengagePaymentCompleted = (data) => {
  let credentials = {
    eventName: 'Checkout Ended',
    data: {
      Phone: '+91' + data.phoneNumber?.trim(),
      'Product Names': data.commonAnalyticsData.product_name_array,
      'Product Ids': data.commonAnalyticsData.pidArr,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Products: JSON.stringify(data.commonAnalyticsData.products),
      Email: data.userAddress?.email?.trim().toLowerCase(),
      Address: data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: Number(data.userAddress?.pincode),
      'Address Type': data.userAddress?.addresstype,
      'Promo Code': data?.commonAnalyticsData.coupon || '',
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment Mode': data.paymentMethod,
      'Total Price': +data.commonAnalyticsData.cart_after_discount,
      'Payment Complete': data.evt.paymentComplete,
      Tag: 'GoKwik',
      'Shipping Charge': Number(data.shippingCharge),
      'Transaction Status': 'successful',
      'Transaction Id': data.orderName,
      'Discount code applied': !!commonAnalyticsData.coupon,
      'Products Name': data.commonAnalyticsData.product_name_array.join(','),
      'Subtotal Price': +data.commonAnalyticsData.cart_after_discount,
      'Total Quantity': data.commonAnalyticsData.total_quantity,
      'Cart Details': data.cart.items,
      'product ID': data.commonAnalyticsData.pidArr.join(','),
      'product Name': data.commonAnalyticsData.product_name_array.join(','),
      'Product ID': data.commonAnalyticsData.pidArr,
      'Product Name': data.commonAnalyticsData.product_name_array,
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'] || '',
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'] || '',
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'] || '',
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'] || '',
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'] || '',
    },
  };
  webengage.track(credentials.eventName, credentials.data);
  webengageNewsletter(data);
};

const webengageNewsletter = (data) => {
  let credentials = {
    eventName: 'Signed Up For News Letter',
    data: {
      'Email Address': data.userAddress?.email?.trim().toLowerCase(),
      Status: true,
      'Landing Page': data.commonAnalyticsData?.marketingData?.['Landing Page'],
      'Origin Referrer': data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      'Utm Source': data.commonAnalyticsData?.marketingData?.['Utm Source'] || '',
      'Utm Medium': data.commonAnalyticsData?.marketingData?.['Utm Medium'] || '',
      'Utm Campaign': data.commonAnalyticsData?.marketingData?.['Utm Campaign'] || '',
      'Utm Term': data.commonAnalyticsData?.marketingData?.['Utm Term'] || '',
      'Utm Content': data.commonAnalyticsData?.marketingData?.['Utm Content'] || '',
    },
  };
  webengage.track(credentials.eventName, credentials.data);
};

const webengagePaymentCompletedGK = (data) => {
  let credentials = {
    eventName: 'Payment_Complete_GK',
    data: createBody({
      'Mobile Number': '+91' + data.phoneNumber?.trim(),
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email?.trim().toLowerCase(),
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: +data.userAddress?.pincode,
      'Address Type': data.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.paymentMethod,
      'Payment Complete': data.evt.paymentComplete,
      'product ID': data.commonAnalyticsData.pidArr.join(','),
      'Product ID': data.commonAnalyticsData.pidArr,
      'product Name': data.commonAnalyticsData.product_name_array.join(','),
      'Product Names': data.commonAnalyticsData.product_name_array,
      'Product Ids': data.commonAnalyticsData.pidArr,
      ...((location.href.includes('almo') ||
        location.href.includes('prolixr') ||
        location.href.includes('dev') ||
        location.href.includes('qa-gokwik') ||
        location.href.includes('sandbox')) && {
        'Products Name': data.commonAnalyticsData.product_name_array.join(','),
      }),
    }),
  };
  webengage.track(credentials.eventName, credentials.data);
  location.href.includes('neemans') && webengagePaymentCompleted(data);
};

const webengageUserAddress = (data) => {
  let credentials = {
    eventName: data.eventName,
    data: createBody({
      'First Name': data.evt.userAddress.firstname,
      'Last Name': data.evt.userAddress.lastname,
      Email: data.evt.userAddress?.email?.trim().toLowerCase(),
      'Full Address': data.evt.userAddress.address,
      City: data.evt.userAddress.city,
      State: data.evt.userAddress.state,
      /* Address selected - string
			Add added - number */
      Pincode:
        data.eventName === 'Address_Selected_GK' ? '' + data.evt.userAddress.pincode : +data.evt.userAddress.pincode,
      'Address Type': data.evt.userAddress.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      'Abandoned URL': `${location.origin}?mrid=${commonAnalyticsData.request_id}`,
      ABC_sms: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=webeng&src=sms`,
      ABC_mail: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=webeng&src=mail`,
      ABC_wa: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=webeng&src=wa`,
      ABC_limechat: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=webeng&src=limechat`,
      ABC_zoko: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=webeng&src=zoko`,
      ABC_gupshup: `${location.origin}?mrid=${commonAnalyticsData.request_id}&ch=webeng&src=gupshup`,
      abc_id: commonAnalyticsData.request_id,
      abc_mrid: `mrid=${commonAnalyticsData.request_id}`,
      'Mobile Number': `+91${data.phoneNumber}`,
      'product ID': data.commonAnalyticsData.pidArr.join(','),
      'Product ID': data.commonAnalyticsData.pidArr,
      'product Name': data.commonAnalyticsData.product_name_array.join(','),
      'Product Name': data.commonAnalyticsData.product_name_array,
    }),
  };
  data.analyticsPixelObj?.webengage?.value === 'email' &&
    webengage.user.login(data.evt.userAddress.email?.trim().toLowerCase());

  webengage.user.setAttribute('we_email', data.evt.userAddress?.email?.trim().toLowerCase());
  webengage.user.setAttribute('we_first_name', data.evt.userAddress.firstname);
  webengage.user.setAttribute('we_last_name', data.evt.userAddress.lastname);
  webengage.track(credentials.eventName, credentials.data);
};
